const responseHandler = (response) => {
  if (!response || typeof response !== "object")
    return {
      ok: false,
      serverError: true,
      message: "Internal server error.",
    };

  const resStatus = response.status;
  if (typeof resStatus === "boolean" && !resStatus) {
    return {
      ok: false,
      serverError: true,
      message: "Internal server error.",
    };
  }

  if (typeof resStatus === "object" && !resStatus.success) {
    return {
      ok: false,
      serverError: false,
      message: resStatus.message,
    };
  }

  if (typeof resStatus === "boolean") {
    return {
      ok: true,
      message: response.message,
      body: null,
    };
  }

  return {
    ok: true,
    message: resStatus.message,
    body: response.body,
  };
};

export default responseHandler;
